import React from 'react'
import {
  Modal, ModalBody, ModalFooter, ModalHeader,
  Form, FormGroup, Label, Input, Button,
  Col
} from 'reactstrap'
import _ from 'lodash'
import ImageLoader from 'react-imageloader'

import MediaDatabase from 'SharedModules/MediaDatabase'
import NoPicture from 'assets/images/imagePreview.png'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'

import Lang from 'Lang/General'

const Update = props => {
  return(
    <Modal
      size="xl"
      isOpen={ props.showUpdateSocialMedia }
      toggle={ () => props.onChangeSocialMediaHOC( 'showUpdateSocialMedia', false ) }>
      <ModalHeader toggle={ () => props.onChangeSocialMediaHOC( 'showUpdateSocialMedia', false ) }>{ 'Update social media platform' }</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup row>
            <Label sm={2}>{'Name'}</Label>
            <Col sm={ 10 }>
              <Input
                type="text"
                value={ props.selectedSocialMediaPlatform.platform_name }
                onChange={ e => {
                  let tmp = _.cloneDeep( props.selectedSocialMediaPlatform )
                  tmp[ 'platform_name' ] = e.target.value
                  props.onChangeSocialMediaHOC( 'selectedSocialMediaPlatform', tmp )
                }} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={2}>{ 'Icon' }</Label>
            <Col sm={ 10 } className="d-flex flex-column">
              <ImageLoader
                src={ props.selectedSocialMediaPlatform.icon_url === '' ? NoPicture : props.selectedSocialMediaPlatform.icon_url }
                imgProps={{ style:{ width: '150px', height: '150px'} }}
                />
              <Button
                color="primary"
                style={{ marginTop: '10px', width: '150px' }}
                onClick={() => {
                  props.toggleMediaDatabase( true )
                }}>{ 'Media database' }</Button>
            </Col>
          </FormGroup>
        </Form>
        {

        }
        <MediaDatabase
          onSelectedImage={( param ) => {
            let tmp = _.cloneDeep( props.selectedSocialMediaPlatform )
            tmp['icon_url'] = param
            props.onChangeSocialMediaHOC( 'selectedSocialMediaPlatform', tmp )
            props.toggleMediaDatabase( false )
          }} />
        { ( props.data.ajaxReducer.ajaxCallProgress > 0 || props.onLoadSocialMedia ) && <LoadingOverlay /> }
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={ () => props.updateSocialMediaPlatform() }>{ Lang[ 'SUBMIT' ][ props.data.languageReducer.lang ] }</Button>
        <Button color="secondary" onClick={ () => props.onChangeSocialMediaHOC( 'showUpdateSocialMedia', false ) }>{'Cancel'}</Button>
      </ModalFooter>
    </Modal>
  )
}

export default Update
